import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../../../../shared/store/views/entityView";
import { messagesDashboardQuery } from "../../../../shared/utils/entitiesFiltersUtils";
import Widget from "../../../../shared/components/features/widget/Widget";
import ScrollLTR from "../../../../shared/components/ui/scrollLTR/ScrollLTR";
import Message from "../../../../shared/components/features/message/Message";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import noMessagesImg from "../../../../assests/emptyList/message.png";
import classes from "./MessagesWidget.module.css";

const MessagesWidget = () => {

    const { texts, lang } = useSelector(state => state.translate);
    const { userDetails } = useSelector(state => state.auth);
    const messages = useSelector(state => selectEntitiesByFilters(state, messagesDashboardQuery(lang, userDetails?.defaultSchool?.mainClasses?.map(c => c.id) || [])));
    const listRef = useRef(null);

    return (
        <Widget
            color="#BBA9E0"
            title={texts.messagesBoard}
            icon={iconsList.messages}
            className={classes.MessagesWidget}
            contentScrollable={false}
        >
            <div className={classes.MessagesContent}>
                {messages?.length > 0 ?
                    <ScrollLTR height="100%">
                        <div className={classes.MessagesList} ref={listRef}>
                            {messages.map(message =>
                                <Message
                                    key={message.id}
                                    {...message}
                                />
                            )}
                        </div>
                    </ScrollLTR>
                    :
                    <div className={classes.NoMessages}>
                        {texts.noMessages}
                        <img src={noMessagesImg} alt={texts.noMessages} className={classes.EmptyImage} />
                    </div>
                }
            </div>
        </Widget>
    );
};

export default MessagesWidget;
